import script from "./modal-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-base.vue?vue&type=script&setup=true&lang=ts"

import "./modal-base.vue?vue&type=style&index=0&id=832f70bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-832f70bc"]])

export default __exports__